import UtilsData from '@/utilities/UtilsData';
import moment    from 'moment';
import formatter from '@/utilities/Formatter';

export default class mBaseModel {
  constructor(rawModelFields = {}) {
    this._localForceUnfreezeWorkflow = false;
    this._localInitialState          = {};
    this._localValidationStatus      = true;
    this._localValidationResults     = [];
    this.ats                         = {};
    return this;
  }

  setRawFields(rawModelFields = {}) {
    for (let prop of Object.keys(rawModelFields)) {
      if (this.ats.hasOwnProperty(prop)) {
        this.ats[prop] = rawModelFields[prop];
      }
    }
    return this;
  }

  getRawFields(obj = null) {
    const res = {};
    if (obj === null) {
      obj = this.ats
    }
    for (let prop of Object.keys(obj)) {
      if (Array.isArray(obj[prop])) {
        res[prop] = [];
        const arr = obj[prop];
        for (let el of arr) {
          if (el instanceof mBaseModel) {
            res[prop].push(el.getRawFields())
          } else {
            res[prop].push(el)
          }
        }
      } else if (typeof obj[prop] === 'object' && !!obj[prop]) { // @see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
        if (obj[prop] instanceof Date) {
          res[prop] = obj[prop];
        } else {
          res[prop] = this.getRawFields(obj[prop]);
        }
      } else {
        res[prop] = obj[prop];
      }
    }
    return res;
  }

  getRawFieldsFormattedForBackEnd() {
    return this.getRawFields();
  };

  setAsInitialState(obj = {}) {
    if (UtilsData.isEmpty(obj)) {
      this._localInitialState = JSON.parse(JSON.stringify(this.getRawFields()));
    } else {
      this._localInitialState = JSON.parse(JSON.stringify(obj));
    }
  }

  revert() {
    this._localForceUnfreezeWorkflow = true;
    this.setRawFields(this._localInitialState);
  }

  isNew() {
    let res = false;
    if (
      !this.ats.hasOwnProperty('Id') ||
      typeof this.ats.Id == 'undefined' ||
      this.ats.Id == null ||
      this.ats.Id == 0 ||
      this.ats.Id == ''
    ) {
      res = true;
    }
    return res;
  }

  static setSmart(obj, propName, propValue) {
    const prop  = propName;
    const value = propValue;
    if (prop.endsWith('Date') && (value != null)) {
      obj[prop] = moment(value, 'YYYYMMDD').toDate();
    } else if (typeof value === 'number') {
      obj[prop] = formatter.formatAsNumber(value, { minSignsAfterDot: 2, maxSignsAfterDot: 8 });
    } else {
      obj[prop] = value;
    }
  }

  defineModelProperty(modelPropertyName, propertyInfo = {}) {
    const {
      ToUserDataFormatter: toUserDataFormatter = mBaseModel.Formatters.ToUserData.Passthrough,
      ToModelDataFormatter: toModelDataFormatter = mBaseModel.Formatters.ToModelData.Passthrough
    } = propertyInfo;
    Object.defineProperty(this, modelPropertyName + '$', {
      enumerable: false,
      configurable: false,
      get: () => {
        return toModelDataFormatter(modelPropertyName, this.ats[modelPropertyName]);
      },
      set: (value) => {
        this.ats[modelPropertyName] = toUserDataFormatter(modelPropertyName, value);
      }
    });
  }

  static Formatters = {
    ToUserData: {
      Passthrough: function(key, value) {
        return value
      },
      Generic: function(key, value) {
        if (key == null) {
          return value;
        }
        if (key.endsWith('Date') && (value != null)) {
          return moment(value, 'YYYYMMDD').toDate();
        } else if (typeof value === 'number') {
          return formatter.formatAsNumber(value, { minSignsAfterDot: 2, maxSignsAfterDot: 8 });
        }
        return value;
      }
    },
    ToModelData: {
      Passthrough: function(key, value) {
        return value
      }
    }
  }
}
